/*
 * @Author: wzc
 * @Date: 2023-09-07
 * @LastEditors: wzc
 * 超赛平台 多选主题分享(multipleChoiceShare_dialog + multipleChoiceShare_fixedBtn) 基础属性和方法
 * @LastEditTime: 2023-09-07
 * 备注：multipleChoiceShareFixedBtn_modeType 属性 和 changeChooseNumEventHandler 方法是在当前页声明的，因为有些变量用到了当前页的值
 */

import { https_package_findAnalysisItem } from '@api/platfrom_base_api'
export default {
  props: {},
  data() {
    return {
      smallBtnArr: [
        {
          type: 'share',
          name: '分享',
        },
        {
          type: 'check',
          name: '查看',
          val: 0,
        },
        {
          type: 'cancel',
          name: '取消',
        },
      ],
      multipleChoiceShareFixedBtn_model: 'rect',
      multipleChoiceShareFixedBtn_state: 'default',
      dialogItem: null,
      localStorageChooseList: [],
      themeItem: null,
      formatThemeListArr: [],
      // multipleChoiceShareFixedBtn_modeType: {
      //   btnName: '创建今日奖牌',
      //   localStorageName: 'mixtmt_choose_medal',
      //   customkeyArrActJson: {} //当分享时，json里面的字段个数大于1时，需要增加这个对象，用来把1之后的字段值动态添加到json种，如果存在默认是对象
      // },
    }
  },
  created() {
    // this.initFindanalysisItem()
  },
  methods: {
    async initFindanalysisItem() {
      if (this.themeTemplateType) {
        // 有些页面不是通过 findAnalysisItem 来获取主题对象的， 所以通过 this.themeTemplateType 来判断是否需要调用 findAnalysisItem 方法
        this.findAnalysisItem_multipleChoicesShare(this.themeTemplateType)
      }
    },
    // changeChooseNumEventHandler() { 每个页面自定义函数 },
    scrollChangeHandler(scrollTop) {
      // 放到当前页 initScroll  方法中
      if (scrollTop > 3) {
        this.multipleChoiceShareFixedBtn_model = 'circular'
      } else {
        if (this.multipleChoiceShareFixedBtn_model === 'rect') {
          this.multipleChoiceShareFixedBtn_model = 'rect'
        }
      }
    },
    getLocalStorageChooseObj(localStorageName) {
      return JSON.parse(this.$localStorage.getItem(localStorageName))
    },
    changeModelEventHandler(val) {
      this.multipleChoiceShareFixedBtn_model = val
      console.debug('changeModelEventHandler:', this.matchList)
    },
    clickFixedBtnEventHandler(val) {
      if (this.multipleChoiceShareFixedBtn_clickFixedBtnBeforeHandler) {
        this.multipleChoiceShareFixedBtn_clickFixedBtnBeforeHandler()
      }
      if (val === 'choose') {
        // 当用户点击【创建主题】，如果赛季不一样，清除缓存数据；否则读取缓存数据
        this.isClearlearLocalStorageChoose()
      }
      this.multipleChoiceShareFixedBtn_state = val
    },
    clickSmallBtnEventHandler(data) {
      if (data && data.dialogType === 'check') {
        console.debug('clickSmallBtnEventHandler:', data, data.dialogText)
        const chooseObj = this.getLocalStorageChooseObj(
          this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        console.debug('chooseObj:', chooseObj)
        this.localStorageChooseList =
          chooseObj && chooseObj.chooseItemArr ? chooseObj.chooseItemArr : []
      }
      this.dialogItem = JSON.parse(JSON.stringify(data))
      console.debug('dialogItem:', this.dialogItem)
    },
    async dialogCancelEventHandler(val) {
      // 弹窗中【取消|关闭弹窗】按钮，不是分享按钮中的取消创建主题
      // console.debug('dialogCancelEventHandler:', this.themeItem, val)
      this.dialogItem = null
    },
    async dialogOkEventHandler(val) {
      console.debug('dialogOkEventHandler:', this.themeItem, val)
      if (val === 'cancel') {
        this.shareDoneEventHandler()
      }
    },
    shareDoneEventHandler(data) {
      console.debug('shareDoneEventHandler:', data)
      // 分享成功之后 || 清空主题数据时
      this.dialogItem = null
      this.multipleChoiceShareFixedBtn_state = 'default'
      this.localStorageChooseList = [] //清空
      this.clearLocalStorageChooseHandler()
      if (data && data.flag) {
        // 分享成功会有 data 且 data.flag = true
      }
    },
    isClearlearLocalStorageChoose() {
      // const dateObj = new Date(this.currStageMatchDate)
      // const year = dateObj.getFullYear()
      // const month =
      //   dateObj.getMonth() + 1 > 9
      //     ? dateObj.getMonth() + 1
      //     : `0${dateObj.getMonth() + 1}`
      // const date =
      //   dateObj.getDate() > 9 ? dateObj.getDate() : `0${dateObj.getDate()}`
      // const currDate = `${year}-${month}-${date}`

      console.debug("isClearlearLocalStorageChoose:", this.multipleChoiceShareFixedBtn_modeType)
      if (!this.multipleChoiceShareFixedBtn_modeType) return //主题没有数据时，this.multipleChoiceShareFixedBtn_modeType = null
      const chooseObj = this.getLocalStorageChooseObj(
        this.multipleChoiceShareFixedBtn_modeType.localStorageName
      )
      console.debug("isClearlearLocalStorageChoose:", chooseObj, this.currCid)
      if (chooseObj) {
        if (chooseObj.cid === this.currCid) {
          this.changeChooseNumEventHandler({
            localStorageName:
              this.multipleChoiceShareFixedBtn_modeType.localStorageName,
            type: this.multipleChoiceShareFixedBtn_modeType.type,
            val: chooseObj.chooseIdArr.length,
            init: false,
          })
        } else {
          // 赛季不同，说明chooseId基本上就对不上了，隐藏清除
          this.clearLocalStorageChooseHandler()
        }
      } else {
        // 如果不存在，也不需要清除缓存
        this.clearLocalStorageChooseHandler()
      }
    },
    clearLocalStorageChooseHandler() {
      // 清除缓存记录
      this.changeChooseNumEventHandler({
        localStorageName:
          this.multipleChoiceShareFixedBtn_modeType.localStorageName,
        type: this.multipleChoiceShareFixedBtn_modeType.type,
        val: 0,
        init: true,
      })
    },
    async findAnalysisItem_multipleChoicesShare(templateType) {
      // 获取所有主题信息
      const params = {
        templateType,
        cid: this.currCid,
        sid: this.crossSeason ? 0 : this.currSid, //跨赛季这里传0
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      console.debug('https_package_findAnalysisItem:', params)
      await https_package_findAnalysisItem(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const themeList = res.data

            if (themeList && themeList.length > 0) {
              let formatThemeListArr = themeList.map((item) => {
                let newItem = JSON.parse(JSON.stringify(item))
                if (newItem.graphicsId) {
                  newItem.actJson = JSON.parse(newItem.json)
                  newItem.renderData = null
                  console.debug(
                    'newItem.analysisItemStyles:',
                    newItem.analysisItemStyles
                  )
                  if (newItem.analysisItemStyles) {
                    // 如果 analysisItemStyles 个数只有1个，则默认选第一个，如果有多个则不需要选默认的
                    let initAct =
                      newItem.analysisItemStyles.length === 1 ? true : false
                    newItem.analysisItemStyles.forEach(
                      (styleItem, styleIndex) => {
                        if (initAct && styleIndex === 0) {
                          styleItem.act = true
                        } else {
                          styleItem.act = false
                        }
                      }
                    )
                  }
                  return newItem
                }
              })
              if (this.multipleChoiceShareFixedBtn_changeOptions) {
                this.formatThemeListArr = formatThemeListArr
              }
              if (this.multipleChoiceShare_initThemeListCallback) {
                this.multipleChoiceShare_initThemeListCallback(
                  formatThemeListArr
                )
              }
              this.themeItem = formatThemeListArr[0]
            } else {
              this.themeItem = null
              this.multipleChoiceShare_initThemeListCallback(null)
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
